import { LoadingState } from '@core/utility/state';
import { Action, createReducer, on } from '@ngrx/store';
import { IdentityActions } from './identity.actions';
import { IdentityState, initialIdentityState } from './identity.state';

export const identityReducerFn = createReducer(
  initialIdentityState,
  on(IdentityActions.fetchIdentity, state => ({
    ...state,
    requestState: LoadingState.LOADING,
  })),
  on(IdentityActions.fetchIdentitySucceeded, (state, { account }) => ({
    ...state,
    account,
  })),
  on(IdentityActions.fetchIdentityFailed, (state, { error }) => ({
    ...state,
    requestState: { error },
  })),
  on(IdentityActions.fetchGeneralContractorSucceeded, (state, { generalContractor }) => ({
    ...state,
    generalContractor,
    requestState: LoadingState.LOADED,
  })),
  on(IdentityActions.fetchGeneralContractorFailed, state => ({
    ...state,
    generalContractor: null,
    requestState: LoadingState.LOADED,
  })),
  on(IdentityActions.noContractorNumberPresentInToken, state => ({
    ...state,
    generalContractor: null,
    requestState: LoadingState.LOADED,
  }))
);

export const identityReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IdentityState = initialIdentityState,
  action: Action
): IdentityState => {
  return identityReducerFn(state, action);
};
